import { isArray } from 'lodash';
import { AvailabilityType, JsonData, ServiceType } from 'types';

const canBeRemoteService = (serviceType: ServiceType | ServiceType[]): boolean => {
  return (
    (isArray(serviceType) &&
      (serviceType.includes(ServiceType.Remote) || serviceType.includes(ServiceType.GeekCover))) ||
    serviceType === ServiceType.Remote ||
    serviceType === ServiceType.GeekCover
  );
};

export const getServiceFormat = (selectedProducts: JsonData, availableProducts: JsonData | null): AvailabilityType => {
  if (!selectedProducts || !availableProducts) {
    return AvailabilityType.OnSite; // Onsite by default if data is null or undefined
  }

  const anyProductNotAvailableForRemote = selectedProducts.some((selected) => {
    const product = availableProducts.find((p) => p.ID === parseInt(selected.id, 10));
    if (!product || product.geekcover_signup_period) {
      // the GeekCover sign-up product is an add-on marker, not work - it never decides remote/on-site
      return false;
    }
    return !canBeRemoteService(product.service_type);
  });

  return anyProductNotAvailableForRemote ? AvailabilityType.OnSite : AvailabilityType.Remote;
};

export const hasGeekCoverSignupProduct = (selectedProducts: JsonData, availableProducts: JsonData | null): boolean => {
  if (!selectedProducts || !availableProducts) {
    return false;
  }

  return selectedProducts.some((selected) => {
    const product = availableProducts.find((p) => p.ID === parseInt(selected.id, 10));
    return Boolean(product?.geekcover_signup_period);
  });
};
